export enum UnserviceableStatu {
  None = 0,
  NotShippedYet = 1,
  Offered = 2,
  Accepted = 3,
  Rejected = 4,
  EightWingShipped = 5,
  OpenedAfterRejection = 99,
}

export enum UnserviceableStatuText {
  None = "None",
  NotShippedYet = "NOT SHIPPED YET",
  Offered = "OFFERED",
  Accepted = "ACCEPTED",
  Rejected = "REJECTED",
  EightWingShipped = "EightWing Shipped",
  OpenedAfterRejection = "OPENED AFTER REJECTION",
}

export const GetUnserviceableStatus = [
  { Description: "NONE", Value: UnserviceableStatu.None },
  { Description: "NOT SHIPPED YET", Value: UnserviceableStatu.NotShippedYet },
  { Description: "OFFERED", Value: UnserviceableStatu.Offered },
  { Description: "ACCEPTED", Value: UnserviceableStatu.Accepted },
  { Description: "REJECTED", Value: UnserviceableStatu.Rejected },
  { Description: "EightWing Shipped", Value: UnserviceableStatu.EightWingShipped },
  { Description: "OPENED AFTER REJECTION", Value: UnserviceableStatu.OpenedAfterRejection },
];
